const currentTradeinItem = JSON.parse(sessionStorage.getItem('currentTradeinItem')) || {};
const tradeinPromoDetails = JSON.parse(sessionStorage.getItem('tradeinPromoDetails'));
const confirmButton = document.getElementById('trade-in-more-questions__confirm-button');
const dropdownLabels = document.querySelectorAll('.dropdown-label-english');
const dropdownSelects = document.querySelectorAll('.dropdown-select');
const freetextLabels = document.querySelectorAll('.freetext-label-english');
const freetextAreas = document.querySelectorAll('.freetext-area');
const radioInputLabels = document.querySelectorAll('.radio-label-english');
const radioInputs = document.querySelectorAll('trade-in-more-questions__radio-input');
const multiselectLabels = document.querySelectorAll('.multiselect-label-english');
const multiselectInputs = document.querySelectorAll('.trade-in-more-questions__checkbox-input');
const itemName = document.getElementById('trade-in-more-questions__item-name');
const itemBrand = document.getElementById('trade-in-more-questions__item-brand-name');
const itemStyleNumber = document.getElementById('trade-in-more-questions__item-style-number');
const itemImageMobile = document.getElementById('trade-in-more-questions__item-image__mobile');
const itemImageDesktop = document.getElementById('trade-in-more-questions__item-image__desktop');
const itemImageWrapper = document.querySelector('.trade-in-more-questions__image-thumbnail-wrapper');
const sliderComponent = document.querySelector('.slider');
const sliderLeft = document.querySelector('.slider-button--prev');
const sliderRight = document.querySelector('.slider-button--next');
const sliderCount = document.querySelector('.slider-counter--current');
const content = document.querySelector('.trade-in-more-questions__content')
const estimatedValue = document.getElementById('trade-in-more-questions__estimated-value');
const estimatedPrepromoValue = document.getElementById('trade-in-more-questions__estimated-prepromo-value');
const promotionText = document.querySelector('.trade-in-more-questions__promotion-text');
const estimatedValueLabel = document.getElementById('trade-in-more-questions__estimated-value-label');
const modalTermsAndConditionsContent = document.querySelector('.modal-terms-and-conditions__content');
const backLink = document.querySelector('.trade-in-more-questions__back-link');

const {
  isUnknown,
  departmentDisplay,
  categoryDisplay,
  subcategoryDisplay,
  catalogItemTitle,
  catalogItemBrand,
  parentSku,
  itemImageUrl,
  colorCode,
  tradeinValue,
  displayTradeinValue,
  isConditionGradingEnabled,
} = currentTradeinItem;

const imageUrls = currentTradeinItem.images?.map(image => image.url);

const setDisplayImages = (src) => {
  itemImageMobile.src = src;
  itemImageDesktop.src = src;

  if (src) {
    imageUrls?.forEach((imageUrl, i) => {
      if (i !== 0) {
        const itemImageThumbnail = document.createElement('img');
        itemImageThumbnail.src = imageUrl;
        itemImageWrapper.appendChild(itemImageThumbnail);
      }
    });
  } else {
    imageUrls?.forEach((_, i) => {
      if (i !== 0) {
        const itemImageThumbnail = document.createElement('img');
        itemImageThumbnail.src = localStorage.getItem('cameraShyImageUrl');
        itemImageWrapper.appendChild(itemImageThumbnail);
      }
    });
  }
};

setDisplayImages(itemImageUrl || localStorage.getItem('cameraShyImageUrl'));

if (isUnknown) {
  itemName.textContent = `${departmentDisplay} ${categoryDisplay} ${
    subcategoryDisplay ? `- ${subcategoryDisplay}` : ''
  }`;
  itemStyleNumber.classList.add('hidden');
  itemImageMobile.classList.add('hidden');
  itemImageDesktop.classList.add('hidden');
  content.firstElementChild.style.display = "none";
  content.lastElementChild.style.width = "100%";
} else {
  itemName.textContent = catalogItemTitle || `${departmentDisplay} ${categoryDisplay}`;
  itemStyleNumber.textContent = `${TRADEIN_MORE_QUESTIONS_CONFIG.styleNoLabel} ${parentSku}`;

  if (itemBrand) {
    itemBrand.textContent = catalogItemBrand || '';
  }
}

backLink.href = `${Shopify.routes.root}pages/${
  isConditionGradingEnabled ? 'trade-in-condition-grading' : 'trade-in-eligibility'
}`;
backLink.textContent = isConditionGradingEnabled ?
  TRADEIN_MORE_QUESTIONS_CONFIG.backToConditionGradingText :
  TRADEIN_MORE_QUESTIONS_CONFIG.backToEligibilityText;

if (tradeinValue !== displayTradeinValue) {
  estimatedPrepromoValue.textContent = formatMoneyForTradein(displayTradeinValue);
  estimatedPrepromoValue.classList.remove('hidden');
  promotionText.classList.remove('hidden');
  estimatedValueLabel.firstElementChild.style.setProperty('font-weight', '600', 'important');
}
estimatedValue.textContent = formatMoneyForTradein(tradeinValue);

if (tradeinPromoDetails) {
  modalTermsAndConditionsContent.textContent = tradeinPromoDetails.tradeinPromoDetails?.termsAndConditions;
}

if (isUnknown) {
  sliderComponent.classList.add('hidden');
  itemImageMobile.classList.add('hidden');
} else if (imageUrls?.length === 1) {
  sliderComponent.classList.add('hidden');
} else {
  itemImageMobile.classList.add('hidden');
}

let imageIndex = 1;
const imageToDisplay = document.getElementById('Slide-1').querySelector('img');
if (imageUrls) {
  imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
  const imageTotal = document.querySelector('.slider-counter--total');
  imageTotal.textContent = imageUrls.length - 1;
  sliderLeft.setAttribute('disabled', true);
}

const requirementMap = {};
let isRequirementMapEmpty = true;
const allLabels = [
  ...dropdownLabels,
  ...freetextLabels,
  ...radioInputLabels,
  ...multiselectLabels,
];
allLabels.forEach(label => {
  if (label.attributes.required.value === 'true') {
    const keyifiedLabel = label.innerText.replaceAll(' ', '_')
    requirementMap[keyifiedLabel] = false;
    isRequirementMapEmpty = false;
  }
});
if (isRequirementMapEmpty) {
  confirmButton.disabled = false;
}

const submitTradeinDataSelection = async () => {
  const data = {};
  dropdownLabels.forEach((label, index) => {
    const keyifiedLabel = label.innerText.replaceAll(' ', '_')
    const dropdown = dropdownSelects[index];
    data[keyifiedLabel] = dropdown.options[dropdown.selectedIndex].value;
  });
  freetextLabels.forEach((label, index) => {
    const keyifiedLabel = label.innerText.replaceAll(' ', '_');
    const freetextArea = freetextAreas[index];
    data[keyifiedLabel] = freetextArea.value;
  });
  radioInputs.forEach((input) => {
    if (input.checked) {
      data[input.name] = input.value;
    } else if (!data[input.name]) {
      data[input.name] = null;
    }
  });
  const multiselectors = new Map();
  let values;
  multiselectInputs.forEach((input) => {
    const [key] = input.id.split('__');
    if (!multiselectors.has(key)) {
      values = [];
      multiselectors.set(key, values);
    }
    if (input.checked && input.id.startsWith(key)) {
      values.push(input.value);
    }
  });
  multiselectors.forEach((value, key) => {
    data[key] = value;
  });

  sessionStorage.setItem('currentTradeinItem', JSON.stringify({
    ...currentTradeinItem,
    data,
  }));
  return addItemAndRedirectToCart();
};

const fieldChange = (event) => {
  requirementMap[event.target.id] = true;
  const allRequiredFieldsFilled = Object.values(requirementMap).every(value => value);
  if (allRequiredFieldsFilled) {
    confirmButton.disabled = false;
  }
};

function selectImage(option) {
  if (option === 'prev') {
    imageIndex--;
    imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
    sliderRight.removeAttribute('disabled');
    if (imageIndex === 1) {
      sliderLeft.setAttribute('disabled', true);
    }
  } else {  //option === 'next'
    imageIndex++;
    imageToDisplay.setAttribute('src', normalizeUrl(imageUrls[imageIndex], { width: '300', height: '300' }));
    sliderLeft.removeAttribute('disabled');
    if (imageIndex === imageUrls.length - 1) {
      sliderRight.setAttribute('disabled', true);
    }
  }
  sliderCount.textContent = imageIndex;
}

sliderLeft.addEventListener('click', () => selectImage('prev'));
sliderRight.addEventListener('click', () => selectImage('next'))
dropdownSelects.forEach(dropdown => dropdown.addEventListener('change', fieldChange));
freetextAreas.forEach(freetextArea => freetextArea.addEventListener('change', fieldChange));
radioInputs.forEach(radioInput => radioInput.addEventListener('change', fieldChange));
confirmButton.addEventListener('click', submitTradeinDataSelection);

const allRequiredFieldsFilled = Object.values(requirementMap).every(value => value);
if (allRequiredFieldsFilled) {
  confirmButton.disabled = false;
}